'use client';

import { Raleway, Open_Sans } from "next/font/google";

const raleway = Raleway({
  variable: "--font-raleway",
  subsets: ["latin"],
});
const openSans = Open_Sans({
  variable: "--font-open-sans",
  subsets: ["latin"],
});

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en" className={`${openSans.variable} ${raleway.variable}`}>
      <body className="min-h-screen flex items-center justify-center bg-white font-sans">
        <div className="text-center p-8 max-w-md">
          <h1 className="text-4xl font-black text-slate-900 mb-4 font-serif">Critical Error</h1>
          <p className="text-slate-600 mb-8">We have encountered an unexpected system failure. Our engineering team has been notified.</p>
          <button 
            onClick={() => reset()}
            className="px-6 py-3 bg-teal-600 text-white rounded-lg font-bold shadow-md hover:bg-teal-700 transition-colors"
          >
            Attempt Recovery
          </button>
        </div>
      </body>
    </html>
  );
}
